export const BANNER_SET = 'BANNER_SET';
